import React, { useState } from "react";
import "../../styles/components/ServicesHero.css";

import servicesBg from "../../img/hero/contacts-hero-2.webp";
import btnArrow from "../../img/hero/arrow-herro.png";

import Modal from "../../components/Modal";            // ✅ модалка
import ContactFormSimple from "../../components/ContactFormSimple"; // ✅ форма

export default function ServicesHero() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="services-hero services-hero-anim" aria-label="Services hero">
      {/* Правий образ */}
      <img
  className="services-hero-bg services-hero-anim__art"
  src={servicesBg}
  alt=""
  aria-hidden="true"
/>

      {/* Лівий блок зі заголовком */}
      <div className="services-hero__art-left services-hero-anim__title">

        <h1 className="services-hero__title">
          Our <strong>services</strong>
        </h1>
      </div>

      {/* Рядок: підзаголовок + кнопка */}
      <div className="services-hero__bottom services-hero-anim__bottom">
        <p className="services-hero__mission">
          Personalized AI agents, analytics, content generation,
          and marketing automation — built on deep user context
          and designed to move your product metrics.
        </p>

        <button
          className="Secondary v2"
          type="button"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Start Your Project</span>
          {btnArrow ? (
            <img
              className="Secondary__circle"
              src={btnArrow}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <span className="Secondary__circle">➜</span>
          )}
        </button>
      </div>

      {/* Модалка */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
